import React from "react";
import { Controller, FieldErrors, Control } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { SxProps, Theme } from "@mui/material";
// import AutocompleteFilter from './AutoCompleteFilter';
import CustomAutocompleteFilter from "./CustomAutocompleteFilter";
export interface Option {
  value: string | number;
  label: string;
}

interface AutocompleteSelectProps {
  fieldName: string;
  label: string;
  control: Control<any, any>;
  errors: FieldErrors<any>;
  options: Option[];
  fontSize?: number;
  width?: number | string;
  size?: "small" | "medium";
  style?: React.CSSProperties;
  sx?: SxProps<Theme>;
  autoCompleteInput?: string;
  setAutoCompletInput?: (value: string) => void;
  disabled?: boolean;
}

export default function SelectFreeSoloInput(props: AutocompleteSelectProps) {
  const {
    sx,
    fieldName,
    control,
    fontSize,
    errors,
    width,
    label,
    options,
    autoCompleteInput,
    setAutoCompletInput,
    disabled,
    ...otherProps
  } = props;
  const errorMessage = errors[fieldName]?.message as string | undefined;

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => {
        return <Autocomplete
          {...otherProps}
          options={options}
          freeSolo
          disableClearable
          sx={{ ...sx }}
          inputValue={field.value
            ? options.find((option) => option.value === field.value)?.label
            : undefined}
          onInputChange={(_, newValue: string) => {
            if (!setAutoCompletInput) return;
            setAutoCompletInput(newValue);
          }}
          onChange={(_, item: any) => {
            if (item.value) field.onChange(item.value);
            if (!setAutoCompletInput) return;
            setAutoCompletInput(item.label);
          }}
          filterOptions={(options, state) =>
            CustomAutocompleteFilter(options, state)
          }
          disabled={disabled}
          renderInput={(params) => (
            <TextField
              {...params}
              style={props.style}
              size="small"
              sx={{
                // width: width ?? "200px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "4px",
                },
              }}
              inputProps={{
                ...params.inputProps,
                style: {
                  fontSize: fontSize ?? 16,
                },
              }}
              InputLabelProps={{
                style: { fontSize: fontSize ?? 16 },
              }}
              label={label}
              error={!!errors[fieldName]}
              helperText={errorMessage}
              value={
                field.value
                  ? options.find((option) => option.value === field.value)
                  : null
              }
            />
          )}
        />
      }
      }
    />
  );
}
